import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Section, Field, SelectField } from "@/components/assessment/FormPrimitives";
import { PROPERTY_TYPES, ENTIRE_PRIVATE } from "@/lib/risk";

export const PropertySection = ({ form, set, setNum, properties, onProperty }) => (
  <Section title="Property">
    <Field label="Linked property (optional)">
      <Select value={form.property_id} onValueChange={onProperty}>
        <SelectTrigger data-testid="field-property"><SelectValue placeholder="No property" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">No property</SelectItem>
          {properties.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </Field>
    <Field label="Property type">
      <SelectField value={form.property_type} onChange={set("property_type")} options={PROPERTY_TYPES} testid="field-property-type" />
    </Field>
    <Field label="Entire home or private room">
      <SelectField value={form.entire_or_private} onChange={set("entire_or_private")} options={ENTIRE_PRIVATE} testid="field-entire-private" />
    </Field>
    <Field label="Property max guests">
      <Input type="number" min={1} value={form.property_max_guests} onChange={setNum("property_max_guests")} data-testid="field-max-guests" />
    </Field>
  </Section>
);

export const HostNotesSection = ({ form, set }) => (
  <Section title="Host notes">
    <Field label="Host concern notes (optional)" full hint="Keep notes factual and about the booking — avoid sensitive personal details.">
      <Textarea value={form.host_notes} onChange={(e) => set("host_notes")(e.target.value)} rows={3} placeholder="Anything specific about this booking you'd like to note..." data-testid="field-notes" />
    </Field>
  </Section>
);
